import _get from 'lodash/get';
import _set from 'lodash/set';

export const payJunctionMixin = {
  data() {
    return {
      pollCount: 0,
      timeoutId: null,
      dialogInFlight: false,
    };
  },

  methods: {
  /**
   * @param {Function} [resHandler = null] - Handles response data.
   */
    async processPromptStatus({ asyncRequest, resHandler, setModel = false, displayGrowl = false, requiresPrompts = false }) {
      this.showProgressBar = true;
      this.dialogInFlight = true;
      const { response } = await this.$store.dispatch('editObject/post', {
        url: '/tg/smartterminal/async_prompt_status',
        params: {
          requestid: asyncRequest.requestid,
          async_params: asyncRequest.async_params,
          poll_count: this.pollCount,
        },
        returnResponse: true,
      });
      const self = this;
      if (response.pending) {
        if (displayGrowl && response.poll_count === 1) {
          // Want to make sure dialog has been established, but don't want to spam the user with growls.
          this.$store.dispatch('notify/push', {
            title: 'Swipe Card',
            text: 'Please swipe card on the payment device.',
            type: 'info',
          });
        }
        this.pollCount = response.poll_count;
        if (setModel) {
          // TODO: FIX LINT
          // eslint-disable-next-line vue/no-mutating-props
          _set(this, 'model.requestData.dialogData', [..._get(response, 'async_params.completedprompts', []), ..._get(response, 'async_params.dialogprompts', [])]);
          if (_get(response, 'async_params.currentprompt')) {
            _set(this.model.requestData, 'currentprompt', _get(response, 'async_params.currentprompt'));
          }
        }
        const asyncObj = requiresPrompts ? response : asyncRequest;
        this.timeoutId = setTimeout(() => {
          self.processPromptStatus({ asyncRequest: asyncObj, resHandler, setModel, requiresPrompts });
        }, 2000);
      } else if (response.async_params) {
        this.pollCount = 0;
        this.showProgressBar = false;
        this.dialogInFlight = false;
        if (setModel) {
          if (_get(this, 'model.deviceConfig.storecard')) {
            // eslint-disable-next-line vue/no-mutating-props
            _set(this.model.requestData, 'creditcarddata', _get(response, 'async_params.completedprompts[0]', {}));
          } else {
            // eslint-disable-next-line vue/no-mutating-props
            this.model.requestData.dialogData = _get(response, 'async_params.completedprompts', []);
            this.readyToSave = true;
          }
        }

        // only one storecard request at a time...
        // note for PayJunction the swipe response will return the
        // StoreCard record if one exists
        // this way we do not make another query trip to server
        const res = _get(response, 'async_params.completedprompts[0]', {});
        if (res.type === 'STORECARD') this.storeCardHandler(res, resHandler);
        else if (resHandler) resHandler();
      } else {
        this.showProgressBar = false;
        this.$store.dispatch('notify/push', {
          text: 'No dialog responses found, please try again!',
        });
      }
    },

    /**
     * @param {Function} [resHandler = null] - Handles response data.
     */
    async startAsyncPrompt({ resHandler = null, isSerialNumberField = false, isDialogModal = false, displayGrowl = false, requiresPrompts = false }) {
      if (!this.model.smartTerminalId) {
        this.$store.dispatch('notify/push', {
          text: 'Card Reader is required, please select one and try again!',
        });
        if (isSerialNumberField) {
          this.updateValue({
            key: '_smartTerminalId_errors',
            value: ['Card Reader is required, please select one and try again!'],
            path: this.parentPath,
            userInitiated: false,
          });
        }
        return;
      }
      this.showProgressBar = true;
      const async_params = requiresPrompts ? {
        deviceid: this.model.smartTerminalId,
        dialogprompts: this.prompts,
      } : _get(this, 'model.async_params');
      const { response } = await this.$store.dispatch('editObject/post', {
        url: '/tg/smartterminal/submit_device_prompt',
        params: {
          requestType: 'userdialog',
          deviceid: this.model.smartTerminalId,
          async_params,
        },
        returnResponse: true,
      });
      if (_get(response, 'asyncrequests')) {
        await this.processPromptStatus({
          asyncRequest: response.asyncrequests[0],
          resHandler,
          setModel: isDialogModal,
          displayGrowl,
          requiresPrompts,
        });
      } else {
        this.$store.dispatch('notify/push', {
          text: 'Error starting dialog on specified device!',
        });
      }
    },

    storeCardHandler(res, handler) {
      if (res._response_errors) {
        const message = this.$store.getters['translations/error'](res._response_errors);
        if (this.$store.getters['auth/showDeviceDialogModal']) {
          this.$store.dispatch('auth/toggleDeviceDialogModal', { showModal: false });
        }
        this.notify(message);
        return;
      }
      handler(res);
    },

    notify(message = '') {
      const text = message || 'No store card found (or bad card swipe), please try again!';
      this.$store.dispatch('notify/push', { text });
    },

    clearTimer() {
      clearTimeout(this.timeoutId);
    },
  },
};
